import { inject, Injectable } from '@angular/core';

import { Customer } from '../../../../model/customer.model';
import { RetailCrmAccountDetailsResponse } from '../../model/responses/account-details.model';
import { RetailCrmCustomerFieldsViewModelMapper } from './customer-fields-model.mapper';
import { RetailCrmDealerConsentViewModelMapper } from './dealer-consent-model.mapper';

@Injectable({
  providedIn: 'root',
})
export class RetailCrmCustomerViewModelMapper {
  private readonly customerFieldsModelMapper = inject(RetailCrmCustomerFieldsViewModelMapper);
  private readonly dealerConsentModelMapper = inject(RetailCrmDealerConsentViewModelMapper);

  mapToCustomer(accountDetails: RetailCrmAccountDetailsResponse): Customer {
    return {
      accountNumber: accountDetails.accountNumber,
      gcid: accountDetails.gcid,
      bmwMiniId: accountDetails.bmwOrMiniId,
      dmsIds: accountDetails.dmsIds,
      firstName: accountDetails.name.firstName,
      lastName: accountDetails.name.lastName,
      middleName: accountDetails.name.middleName,
      suffix: accountDetails.name.suffix,
      correspondenceLanguage: accountDetails.correspondenceLanguage,
      salutation: this.customerFieldsModelMapper.mapSalutation(accountDetails.name.salutation),
      title: this.customerFieldsModelMapper.mapTitle(accountDetails.name.title),
      businessContact: this.customerFieldsModelMapper.mapContact(
        accountDetails.businessAddress,
        accountDetails.connection,
        'business',
      ),
      privateContact: this.customerFieldsModelMapper.mapContact(
        accountDetails.privateAddress,
        accountDetails.connection,
        'private',
      ),
      vehicles: this.customerFieldsModelMapper.mapVehicles(accountDetails.vehicleInformation),
      inSyncWithDirectSales: accountDetails.inSyncWithDirectSales,
      dealerConsent: this.dealerConsentModelMapper.mapDealerConsent(accountDetails.privacyConsent),
      taxNumber: accountDetails.taxNumber,
      taxNumberCountry: accountDetails.taxNumberCountry,
      nationalId1: accountDetails.nationalId1,
      nationalId1DocumentType: this.customerFieldsModelMapper.mapNationalIdDocumentType(
        accountDetails.nationalId1DocumentType,
      ),
    };
  }
}
